<template>
  <el-dialog :visible.sync="visible" title="收款记录" :close-on-click-modal="false"
             :close-on-press-escape="false" width="80%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item label="出口发票号：">
        {{ dataForm.receiptCode }}
      </el-form-item>
      <el-form-item label="收款户头：">
        <common-drop :is-page-url="true" label-name="accountName" url="/trade/myaccount/page?page=1&limit=100"
                     v-model="dataForm.accountId" size="mini" :auto-default="false"
                     placeholder="请选择收款户头"></common-drop>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="dataListLoading" :data="dataList" border show-summary
              :summary-method="getSummaries" style="width: 100%;">
      <el-table-column type="index" label="行号" header-align="center" align="center" width="50"></el-table-column>
      <el-table-column prop="batchCode" label="收款批次" header-align="center" align="center"></el-table-column>
      <el-table-column prop="amount" label="收款金额" header-align="center" align="center"></el-table-column>
      <el-table-column prop="totalAmount" label="批次总额" header-align="center" align="center"></el-table-column>
      <el-table-column prop="receiptCode" label="出口发票号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="customerName" label="客户" header-align="center" align="center"></el-table-column>
      <el-table-column prop="currency" label="货币" header-align="center" align="center"></el-table-column>
<!--      <el-table-column prop="accountName" label="收款户头" width="200" header-align="center"-->
<!--                       align="center"></el-table-column>-->
      <el-table-column prop="bankName" label="收款行" header-align="center" align="center"></el-table-column>
      <el-table-column prop="accountNo" label="收款账号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="operateDate" label="收款日期" header-align="center" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
    </el-pagination>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import CommonDrop from '@/components/CommonDrop'
import BigNumber from 'bignumber.js'

export default {
  name: 'log-dialog',
  mixins: [mixinViewModule],
  components: { CommonDrop },
  data () {
    return {
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/trade/receivelog/page',
        getDataListIsPage: true,
        activatedIsNeed: false
      },
      dataForm: {
        customerName: '',
        receiptCode: '',
        accountId: ''
      }
    }
  },
  methods: {
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价'
          return
        }
        if (column.property !== 'amount') {
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            let value = Number(curr)
            if (!isNaN(value)) {
              return new BigNumber(prev).plus(curr).toFixed(2)
            } else {
              return prev
            }
          }, 0)
        }
      })
      return sums
    },
    init (receiptCode) {
      this.dataForm.receiptCode = receiptCode
      this.reload()
      this.visible = true
    }
  },

}
</script>
